import { request, exportCsvData, importData, downloadTemplate } from "./api";
import { PurchaseInterface } from "../types";

const BASE_PATH = `/purchases`;

interface SendReqConfig {
  method?: "GET" | "POST" | "PUT" | "DELETE";
  id?: string;
  data?: Partial<PurchaseInterface>;
  params?: string;
}

export async function sendReq({
  method = "GET",
  id,
  data,
  params = "",
}: SendReqConfig = {}): Promise<any> {
  return await request({ method, id, data, params, basePath: BASE_PATH });
}

export interface PaginatedPurchasesResponse {
  data: PurchaseInterface[];
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
}

export async function getPurchases(
  params?: string,
): Promise<PaginatedPurchasesResponse> {
  return await sendReq({ params });
}

export async function exportPurchases(params?: string): Promise<void> {
  return await exportCsvData(BASE_PATH, params);
}

export async function importPurchases(data: any[]): Promise<any> {
  return await importData(BASE_PATH, data);
}

export async function downloadPurchasesTemplate(): Promise<void> {
  return await downloadTemplate(BASE_PATH);
}

export async function getPurchase(id: string): Promise<PurchaseInterface> {
  return await sendReq({ id });
}

export async function createPurchase(
  data: Partial<PurchaseInterface & { auto_receipt: boolean }>,
): Promise<PurchaseInterface> {
  return await sendReq({ method: "POST", data });
}

export async function updatePurchase(
  id: string,
  data: Partial<PurchaseInterface>,
): Promise<PurchaseInterface> {
  return await sendReq({ method: "PUT", id, data });
}

export async function deletePurchase(id: string): Promise<void> {
  return await sendReq({ method: "DELETE", id });
}

export const getPurchasesByContact = async (
  params: string,
): Promise<{ data: PurchaseInterface[] }> => {
  return await sendReq({ method: "GET", params });
};

export async function approvePurchase(
  related_id: string,
  create_receipt: boolean,
): Promise<PurchaseInterface> {
  return await sendReq({
    method: "PUT",
    params: `action=approvepurchase&related_id=${related_id}&create_invoice=${create_receipt ? "1" : "0"}`,
  });
}

export async function rejectBitPurchase(
  related_id: string,
): Promise<PurchaseInterface> {
  return await sendReq({
    method: "PUT",
    params: `action=rejectbitpurchase&related_id=${related_id}`,
  });
}

export async function getPendingPurchases() {
  return await sendReq({ method: "GET", params: "action=getPendingPurchases" });
}
